import { TPrice } from "../../../DataDisplay/Price";
import { ILinkProps } from "../../../ActionsSelectors/Link/Link";

export type Product = {
  id: string;
  /** Primary name */
  itemName: string;
  /** Product's brand (Nike, Adidas, etc.) */
  brand: string;
  category: string;
  /** Current price with all discounts */
  prices: TPrice[];
  /** Link to the image of a product */
  image: string;
  /** 'Alt' of product's image */
  imageAlt?: string;
};

export type OrderProduct = Product & {
  /** Amount of goods in the order */
  quantity: number;
  /** Status of this particular product (ordered, returned, cancelled, etc.) in the order */
  status: OrderProductStatus;
};

export enum DeliveryType {
  HOME_DELIVERY,
  DEPARTMENT,
  SELF,
}

export type Delivery = {
  id: string;
  type: DeliveryType;
};

export enum OrderStatus {
  NEW,
  ON_THE_WAY,
  COMPLETED,
  CANCELLED,
}

export enum OrderProductStatus {
  ORDERED,
  CANCELLED,
  RETURNED,
}

export type TOrder = {
  id: string;
  /** Current price (without discounts) */
  price: number;
  /** Main date of the order. Has to be in the ISO-8601 format or in timestamp */
  createdAt: string;
  /** Current status (created, cancelled, etc.) */
  status?: OrderStatus;
  /** Delivery information */
  delivery?: Delivery;
  /** Products in order.
   * Has additional `quantity` and `status` fields regarding to `Order` */
  products?: OrderProduct[];
  /** Total amount of products (quantities of all products combined) in the order */
  totalProducts?: number;
  /** Link to delivery service with tracking id.
   * Important to have "text" or "link" property in link's data to show it visually as raw content on the page */
  trackOrderLink?: ILinkProps;
};

export const deliveryTypeText = {
  [DeliveryType.HOME_DELIVERY]: "Home delivery",
  [DeliveryType.DEPARTMENT]: "Department",
  [DeliveryType.SELF]: "Self",
};

export const orderStatusText = {
  [OrderStatus.NEW]: "New Order",
  [OrderStatus.ON_THE_WAY]: "On the way",
  [OrderStatus.COMPLETED]: "Competed",
  [OrderStatus.CANCELLED]: "Cancelled",
};

export const orderStatusIcon = {
  [OrderStatus.NEW]: "USPClockIcon",
  [OrderStatus.ON_THE_WAY]: "USPTruckIcon",
  [OrderStatus.COMPLETED]: "DoneIcon",
  [OrderStatus.CANCELLED]: "SoldOutIcon",
};
